/**
 * Centralized API configuration
 *
 * Environment variable: REACT_APP_API_URL
 *
 * When set, all API requests use this base URL.
 * - app.cloud-safe.uk: API at backend.cloud-safe.uk (split deployment)
 * - backend.cloud-safe.uk: same origin
 *
 * When not set: development uses http://localhost:8081;
 * production uses same origin ('').
 */

const getApiUrl = () => {
  // Production: when hosted on app/backend.cloud-safe.uk, always use correct URL
  // (avoids .env.local localhost override from leaking into production build)
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host === 'app.cloud-safe.uk') return 'https://backend.cloud-safe.uk'; // API on backend subdomain
    if (host === 'backend.cloud-safe.uk') return ''; // Same origin when served from backend
  }

  let apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl && !apiUrl.includes('localhost')) {
    return apiUrl.replace(/\/$/, '');
  }

  // In development, use an empty base so requests go to the same origin (localhost:3003)
  // and the CRA proxy in package.json forwards them to api.cloud-safe.uk (no CORS).
  return '';
};

// Export the API base URL
export const API_BASE_URL = getApiUrl();

// Helper function to build full API endpoint URLs
export const getApiEndpoint = (endpoint) => {
  // Remove leading slash if present (we'll add it)
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${cleanEndpoint}`;
};

// Export default for convenience
export default API_BASE_URL;

